// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2dpXW","col":"styles_col__11975","fulfillmentStatus":"styles_fulfillmentStatus__3UR9A","emailCol":"styles_emailCol__4G3mh"};